import React, {createContext, useContext, useMemo, useState} from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';

const ColorModeContext = createContext({mode: 'light', setMode: () => {}, toggleMode: () => {}});

// Theme is currently forced to light: localStorage "colorMode" is ignored
// and nothing is persisted. setMode/toggleMode still switch the theme for
// the current session if ever called (the toggle UI is hidden).
export const ColorModeProvider = ({children}) => {
    const [mode, setModeState] = useState('light');

    const setMode = (next) => {
        const value = next === 'dark' ? 'dark' : 'light';
        setModeState(value);
        document.documentElement.setAttribute('data-theme', value);
    };

    const theme = useMemo(() => createTheme({
        palette: {
            mode,
            primary: {main: '#3976EF'},
            ...(mode === 'dark' ? {
                background: {default: '#16181d', paper: '#1c1f26'},
                divider: 'rgba(255, 255, 255, 0.12)',
            } : {}),
        },
    }), [mode]);

    const value = useMemo(() => ({
        mode,
        setMode,
        toggleMode: () => setMode(mode === 'dark' ? 'light' : 'dark'),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [mode]);

    return (
        <ColorModeContext.Provider value={value}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </ColorModeContext.Provider>
    );
};

export const useColorMode = () => useContext(ColorModeContext);
